import * as React from 'react'
import { FormControlLabel, Checkbox, Tooltip } from '@design/pt-ui'

import { Option } from '../interfaces/components/dynamic-form'

interface ICheckBoxListProps {
  options: Option[]
  value: any
  disabled?: boolean
  disabledOptionTooltip?: string
  onChange: (value: any) => void
  multiple?: boolean
}

export default function CheckBoxList(props: ICheckBoxListProps) {
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (props.disabled) {
      return
    }
    const value = event.target.value

    props.onChange(
      props.multiple
        ? props.value.indexOf(value) !== -1
          ? props.value.filter((v: any) => v !== value)
          : [...props.value, value]
        : value,
    )
  }

  const { options, multiple } = props
  const value = multiple ? props.value : [props.value]

  return (
    <>
      {options.map((option, index) => {
        const elem = (
          <FormControlLabel
            control={
              <Checkbox
                disabled={option.disabled || props.disabled || false}
                checked={value.indexOf(option.value) !== -1}
                onChange={handleCheckboxChange}
                value={option.value}
              />
            }
            label={option.label}
          />
        )
        return option.disabled && props.disabledOptionTooltip ? (
          <React.Fragment key={index}>
            <Tooltip
              placement="top"
              title={props.disabledOptionTooltip}
              key={index}>
              {elem}
            </Tooltip>
          </React.Fragment>
        ) : (
          <React.Fragment key={index}>{elem}</React.Fragment>
        )
      })}
    </>
  )
}
